export default {
  /**
   * 校验身份证格式
   */
  verifyIDNumber (number) {
    number = number.toUpperCase()
    if (/^\d{15}$/.test(number)) {
      return true
    }
    if (/^\d{17}(\d|X)$/.test(number)) {
      var code = number.split('')
      // ∑(ai×Wi)(mod 11)
      // 加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      // 校验位
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
      var sum = 0
      var ai = 0
      var wi = 0
      for (var i = 0; i < 17; i++) {
        ai = code[i]
        wi = factor[i]
        sum += ai * wi
      }
      var last = parity[sum % 11]
      if (last != code[17]) {
        return false
      }
      return true
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/verify.js